import { Record } from 'immutable';
import { PurchaseMethodsConstant, PaymentFrequencies } from 'commons-vehicle/PurchaseMethods/index.js';

const PaymentOptionsRecord = Record({
    purchaseMethod: PurchaseMethodsConstant.CASH,
    frequencyValues: [],
    preferredPaymentFrequency: PaymentFrequencies.WEEKLY,
    preferredPurchaseMethod: '',
    terms: [24, 36, 48, 60, 72, 84, 96],
    maximumTerm: 96,
    initialCashDown: 0,
    initialTargetPayment: 0,
    rangeEnabled: false,
    rangeStep: 25,
    rangeBoundaries: [0, 500],
    range: [0, 500],
});

class PaymentOptions extends PaymentOptionsRecord {}

export default PaymentOptions;
